import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';
import FormModalComponent from '72cms-ui/components/helpers/FormModalComponent';
import FormModalAddButtonComponent from '72cms-ui/components/table-elements/FormModalAddButtonComponent';
import FormModalEditButtonComponent from '72cms-ui/components/table-elements/FormModalEditButtonComponent';

export default {
    fields: {
        from_url: {
            label: 'From URL',
        },
        to_url: {
            label: 'To URL',
        },
        is_regex: {
            label: 'Pattern',
        },
    },
    sortable: [],
    filterable: [],
    inlineFormComponent: FormModalComponent,
    formConfig: require('./form.redirect_url').default,
    toolbar: [
        {
            label: 'Add new field',
            component: FormModalAddButtonComponent,
        }
    ],
    hideIfEmpty: false,

    pagination: false,
    searchable: false,
    treeView: false,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: FormModalEditButtonComponent,
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            primary: true,
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.redirect_urls.js